import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainSection() {
  return <section className="w-full max-w-2xl mx-auto px-4 py-16" data-id="element-171">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="space-y-8" data-id="element-172">
        <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-173">
          No necesitas más motivación. <br data-id="element-174" />
          <span className="text-[#FE2C55]" data-id="element-175">
            Necesitas un sistema que no te deje escapar.
          </span>
        </h2>

        <div className="bg-[#111] p-6 rounded-2xl border border-white/5" data-id="element-176">
          <p className="text-xl font-semibold text-gray-200 mb-6" data-id="element-177">
            Si tú también eres de los que:
          </p>
          <ul className="space-y-4" data-id="element-178">
            {['empieza con todo y a los días se apaga', "pasa más tiempo 'aprendiendo' que publicando", 'cambia de producto antes de entender qué funcionó', 'se compara y se paraliza'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-179">
                <div className="mt-1 min-w-[24px] h-6 flex items-center justify-center rounded-full bg-[#FE2C55]/10" data-id="element-180">
                  <X className="w-4 h-4 text-[#FE2C55]" data-id="element-181" />
                </div>
                <span className="text-lg text-gray-300" data-id="element-182">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="space-y-4" data-id="element-183">
          <p className="text-xl text-gray-200" data-id="element-184">
            …entonces no estás perdiendo por falta de capacidad.{' '}
            <span className="text-[#25F4EE] font-bold" data-id="element-185">
              Estás perdiendo por falta de estructura.
            </span>
          </p>
          <p className="text-xl text-gray-200" data-id="element-186">
            Y la estructura correcta para ti no puede ser "haz esto 3 horas al
            día". Porque tu vida no funciona así.
          </p>
        </div>
      </motion.div>
    </section>;
}